module.exports = __webpack_public_path__ + "static/media/soc_rss.3190ae94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc_rss.svg
// module id = 388
// module chunks = 0